import { render, staticRenderFns } from "./DebtorTypeSelect.vue?vue&type=template&id=109772eb&"
import script from "./DebtorTypeSelect.vue?vue&type=script&lang=js&"
export * from "./DebtorTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports